// Likert-Batterie: alle Items einer Skala auf einer Seite, gemeinsame 1-6-Skala oben.
// items: [{ key, text }, ...]
// values: { [key]: 1..6 }
// onChange(key, n) wird beim Klick auf eine Skalen-Stufe aufgerufen.
export default function LikertBatteryStep({ scale, values, onChange, likert, hint }) {
  const numAnswered = scale.items.filter(it => values[it.key]).length

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-teal-700 font-semibold">{scale.code}</div>
        <h1 className="text-2xl font-bold mt-1">{scale.label}</h1>
        {scale.description && (
          <p className="text-ink-soft mt-1.5 text-sm leading-relaxed">{scale.description}</p>
        )}
      </div>

      {/* Skala-Header (Desktop) */}
      <div className="hidden md:grid grid-cols-[1fr_auto] gap-6 items-end pb-2 border-b border-teal-100">
        <div className="text-xs text-ink-mute">{hint}</div>
        <div className="grid grid-cols-6 gap-1 w-[300px]">
          {likert.values.map((n, i) => (
            <div key={n} className="text-[10px] text-ink-mute text-center leading-tight px-0.5">
              <div className="font-semibold text-ink-soft">{n}</div>
              <div className="line-clamp-2">{likert.short[i]}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile-Hinweis zur Skala */}
      <div className="md:hidden flex items-center justify-between text-[11px] text-ink-mute -mt-2">
        <span>1 = überhaupt nicht</span>
        <span>6 = völlig</span>
      </div>

      {/* Items */}
      <ul className="divide-y divide-teal-100/60">
        {scale.items.map((it, i) => (
          <ItemRow
            key={it.key}
            item={it}
            value={values[it.key] || 0}
            likert={likert}
            onChange={(n) => onChange(it.key, n)}
            even={i % 2 === 1}
          />
        ))}
      </ul>

      <div className="text-xs text-ink-mute">
        {numAnswered} von {scale.items.length} bewertet
      </div>
    </div>
  )
}

function ItemRow({ item, value, likert, onChange, even }) {
  return (
    <li className={`grid sm:grid-cols-[1fr_auto] gap-3 sm:gap-6 items-center py-3 px-2 ${even ? 'bg-teal-50/20' : ''}`}>
      <div className="text-ink leading-snug">{item.text}</div>
      <div className="grid grid-cols-6 gap-1.5 sm:w-[300px]">
        {likert.values.map((n) => (
          <ScaleButton key={n} n={n} active={value === n} onClick={() => onChange(n)} />
        ))}
      </div>
    </li>
  )
}

function ScaleButton({ n, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Wert ${n}`}
      className={`h-9 sm:h-8 rounded-full border-2 grid place-items-center text-xs font-semibold transition cursor-pointer
        ${active
          ? 'bg-teal text-white border-teal'
          : 'bg-white text-ink-mute border-teal-200 hover:border-teal-400 hover:text-ink'}`}
    >
      {n}
    </button>
  )
}
